import { Header , Icon , Button , Input , Grid , Message, Modal , Form } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './translations/i18n';
import { useTranslation } from 'react-i18next';

const pjson = require('../package.json')
const homep = (!!pjson.homepage) ? pjson.homepage : '/'
const getToken = `${window.location.origin}${homep}setToken/`

const loginUrl = (process.env.NODE_ENV === 'development') ? `http://localhost/mediatheken/loginDemo.php?origin=${btoa(getToken)}` : `https://lib.arteveldehogeschool.be/mediatheken/loginLink.php?origin=${btoa(getToken)}` 

const Profiel = ({user , modalOpen , onModalClose  }) => {

    localStorage.setItem('redirect',(window.location.pathname).replace(homep,''))
    const navigate = useNavigate()
    const { t , i18n } = useTranslation();
    //const [ profileActive , setProfileActive ] = useState(false)
    //const [ profile , setProfile ] = useState(user)

    const logOff = () => {
        localStorage.removeItem('token')
        onModalClose(false)
        navigate(0)
    }

    const [ email , setEmail ] = useState('')
    const [ valid , setValid ] = useState(false)
    const handleChange = (e , {value} ) => {
        setEmail(value)
        if(validateEmail(value)) {
            setValid(true)
        } else {
            setValid(false)
        }
    } 

    const validateEmail = (email) => {
        return (String(email)
            .toLowerCase()
            .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) && [ 'arteveldehs.be' , 'student.arteveldehs.be' ].some((val) => email.toLowerCase().split('@')[1] === val)) 
    };

    const goToLogin = () => {
        window.open(loginUrl,"_self")
    }

    const handleSubmit = () => {
        if(!!valid) {
            goToLogin()
        }
    }

    return(
            <Modal
                closeIcon
                open={modalOpen}
                onClose={() => onModalClose(false)}
                centered={false}
            >
            {user === null &&
            <>
            <Modal.Header>
                <Icon name='key' />
                {t('login')}
            </Modal.Header>
            
                <Modal.Content>
                <Form
                    handleSubmit
                    error={!!!valid && email.length > 6 ? true : false}
                >
                    <Form.Group inline fluid>
                        <Form.Input 
                            width={14}
                            label={t('enterEmail')}
                            value={email}
                            placeholder={t('enterEmail')}
                            onChange={handleChange}
                        />
                        <Form.Button 
                            fluid
                            positive
                            onClick={handleSubmit}
                            disabled={!!!valid}
                            content={t('login')}
                        />
                    </Form.Group>
                    <Message error
                        header={t('invalidEmailHeader')}
                        content={t('invalidEmail')}
                    />
                </Form>
                
                </Modal.Content>
                <Modal.Actions>
                <Button color='orange' onClick={() => onModalClose(false)} content={t('cancel')}/>
                </Modal.Actions>
            </>}
            {user !== null &&
                <>
                <Modal.Header>
                    <Icon name='user' />
                    {`${t('welcome')}, ${user.loginData_givenName}`}
                </Modal.Header>
                <Modal.Content>
                    <Message warning>
                        {t('UNDER_CONSTRUCTION')}
                    </Message>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={() => logOff()} content={t('logoff')}/>
                </Modal.Actions>
                </>
            }
</Modal>
    )
}

export default Profiel;